<template>
    <div class="page newpage">
        <div class="_flex">
			<el-input v-model="search.nick_name" clearable size="small" placeholder="姓名" style="width: 180px;margin-right: 10px;"/>
            <el-input v-model="search.phone" clearable size="small" placeholder="手机号码" style="width: 180px;margin-right: 10px;"/>
			<el-select v-model="search.is_leader" class="w200 mr_10" size="small" placeholder="是否部门负责人">
				<el-option label="是部门负责人" value="1"></el-option>
                <el-option label="不是部门负责人" value="0"></el-option>
			</el-select>
			<el-select v-model="search.state" class="w200 mr_10" size="small" placeholder="状态">
				<el-option label="正常" value="1"></el-option>
                <el-option label="禁用" value="2"></el-option>
			</el-select>
			<el-button size="small" @click="getAdminLists(1)">筛选</el-button>
            <el-button type="success" size="small" @click="followStateHandle">设置分配员工后客户的跟进状态</el-button>
		</div>
		<div class="_flex_sb mt_20">
			<div class="left bag_f5 p_10 br_8" style="width: 200px;">
                <el-scrollbar style="height: 80vh;">
                <el-tree :data="departArr" :props="defaultProps" node-key="id" :default-expand-all="false" :default-expanded-keys="defaultExpandedKeys" :expand-on-click-node="false" @node-click="selectDepart" highlight-current check-on-click-node style="padding: 10px 0;" />
                </el-scrollbar>
			</div>
			<div class="right" style="width: calc(100% - 200px - 50px);">
				<el-table :data="list" height="70vh" stripe ref="multipleTable" :header-cell-style="{ background:'#f5f5f5'}" v-loading="loading" @selection-change="handleSelectionChange" row-key="admin_id">
					<el-table-column type="selection"  width="55"></el-table-column>
				    <el-table-column prop="admin_id" label="序号" width="100"></el-table-column>
				    <el-table-column prop="nick_name" label="姓名" width="120"></el-table-column>
                    <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
				    <el-table-column prop="group_name" label="职务" width="150"></el-table-column>
                    <el-table-column prop="depart_name" label="部门" min-width="180"></el-table-column>
				    <el-table-column prop="is_leader_text" label="负责人" width="100"></el-table-column>
				    <el-table-column prop="tag_text" label="标签" ></el-table-column>
				    <el-table-column prop="state_text" label="状态" width="100"></el-table-column>
				    <el-table-column prop="applylimit" label="是否已设置" min-width="100"></el-table-column>
				    <el-table-column label="操作" width="100px">
						<template slot-scope="scope">
							<el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
						</template>
				    </el-table-column>
				  </el-table>
				 <div class="mt_30 _flex_sb">
				  <div>
                        <!-- <div class="_button nul">跨页全选</div> -->
                        <el-button type="danger" size="small" @click="clearSelect">清空选择（{{selectedAdmins.length}}）</el-button>
                        <el-dropdown @command="handleCommand">
                            <el-button type="primary" size="small" style="margin-left: 10px;">批量操作 ></el-button>
                            <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="1">部门申请</el-dropdown-item>
                            <el-dropdown-item command="2">员工申请</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
				  </div>
				  <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 50, 100, 200, 300, 500]"
                  @size-change="changeLimit" @current-change="changePage" 
                  :current-page="search.page" :page-size="search.limit" :total="search.total"></el-pagination>
				 </div>
			</div>
		</div>
		
		<el-dialog :title="alertType==1?'指派到部门' :alertType==2?'分配员工':''" :visible="alertType?true:false" width="600px" center @close="alertType=0">
            <el-scrollbar style="height: 60vh;">
                <el-form label-position="right" label-width="90px" v-model="config" class="pr_20" style="margin-right: 10px;">
                    <el-form-item label="层级：">
                        <div class="_flex_sb _f_ai">
                            <div class="w100 t_c">类型</div>
                            <div class="w100 t_c">次/天</div>
                            <div class="w100 t_c">条/次</div>
                        </div>
                    </el-form-item>
                    <el-form-item v-for="(level,index) in config" :key="index" :label="level.name + '：'" >
                        <div class="_flex_sb _f_ai" v-for="(item, ix) in level.children" :key="ix">
                            <div class="w100 t_c">{{item.name}}</div>
                            <div class="w100 t_c"><el-input v-model="item.times_per_day" size="small" class="w100"/></div>
                            <div class="w100 t_c"><el-input v-model="item.limit_per_time" size="small" class="w100"/></div>
                        </div>
                    </el-form-item>
                </el-form>
            </el-scrollbar>
            <span slot="footer">
                <el-button @click="alertType=0">取 消</el-button>
                <el-button type="primary" @click="handleSet" :loading="setloading">确 定</el-button>
            </span>
		</el-dialog>
		
        <el-dialog title="设置分配员工后客户的跟进状态" :visible.sync="followStateVisible" top="30vh" width="500px">
            <el-select v-model="crm_follow_state" clearable placeholder="请选择">
                <el-option v-for="(item,index) in follow_state_arr" :key="index" :label="item.name" :value="item.code"></el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="followStateVisible = false">取 消</el-button>
                <el-button type="primary" @click="followStateSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { adminLists, DepartmentLists, applyGet, applySet, setCrmFollowState } from "@/request/apis.js"
export default{
    data(){
        return {
            loading: false,
            search: {
                nick_name: '',
                phone: '',
                is_leader: '',
                state: '',
                page: 1,
                limit: 10,
                total: 0,
                applylimit: 1,
            },
            departArr: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            selectDepartId: '',
            selectAdminId: '',
            selectedAdmins: [],
            config: {},
			alertType : 0,
            list : [],
            setloading: false,
            followStateVisible: false,
            follow_state_arr: [],
            crm_follow_state: '',
            defaultExpandedKeys: [],
        }
    },
	mounted() {
        this.getDepartmentLists();
        this.getAdminLists();
	},
	methods:{
        async getDepartmentLists(){
            var res = await DepartmentLists({top: 1});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.departArr = res.data;
            this.defaultExpandedKeys = this.getExpandedNodeIds(this.departArr);
        },
        // 获取需要展开的节点 ID
        getExpandedNodeIds(nodes, level = 1, maxLevel = 3) {
            let ids = [];
            
            if (level <= maxLevel && nodes) {
                nodes.forEach(node => {
                    // 只展开前三级，第三级不展开子节点
                    if (level < maxLevel) {
                        ids.push(node.id);
                    }
                    
                    if (node.children && node.children.length > 0 && level < maxLevel) {
                        ids = ids.concat(this.getExpandedNodeIds(node.children, level + 1, maxLevel));
                    }
                });
            }
            
            return ids;
        },
        async getAdminLists(page = 0, depart_id = 0){
            if(page){
                this.search.page = page;
            }
            this.loading = true;
            var res = await adminLists({...this.search, depart_id});
            this.loading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.list = res.data;
            this.search.total = res.count;
            this.tagArr = res.other.tag;
        },
        changeLimit(limit){
            this.search.limit = limit;
            this.getAdminLists(1);
        },
        changePage(page){
            this.getAdminLists(page);
        },
        selectDepart(data){
            this.getAdminLists(1, data.id);
        },
        handleSelectionChange(selection) {
            this.selectedAdmins = selection;
        },
        clearSelect(){
            this.$refs.multipleTable.clearSelection();
        },
        async handleSet(){
            let admin_ids = this.selectAdminId ? [this.selectAdminId] : this.selectedAdmins.map(i => i.admin_id);
            this.setloading = true;
            let res = await applySet({admin_ids, config: this.config});
            this.setloading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.alertType = 0;
            this.getAdminLists();
        },
		async handleCommand(e){
            if(!this.selectedAdmins.length){
                return this.$message.error('请先选择');
            }
            let err = '';
            this.selectedAdmins.forEach(ele => {
                if(e == 1 && ele.is_leader != 1){
                    err = '部门申请请选择部门负责人';
                }
                if(e == 2 && ele.is_leader == 1){
                    err = '员工申请请选择非部门负责人';
                }
            });
            if(err){
                return this.$message.error(err);
            }
            this.selectAdminId = 0;
            let res = await applyGet();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.config = res.data;
            this.alertType = e;
		},
        async edit(admin){
            this.selectAdminId = admin.admin_id;
            this.clearSelect();
            let res = await applyGet({admin_id: admin.admin_id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.config = res.data;
            this.alertType = admin.is_leader == 1 ? 1 : 2;
        },

        async followStateHandle(){
            let res = await setCrmFollowState();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.follow_state_arr = res.data.follow_state_arr;
            this.crm_follow_state = res.data.config.crm_follow_state;
            this.followStateVisible = true;
        },
        async followStateSubmit(){
            let res = await setCrmFollowState({crm_follow_state: this.crm_follow_state}, 'post');
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg || '操作成功');
            this.followStateVisible = false;
        },
	}
}
</script>

<style  scoped>
/deep/.el-tree-node__content{
    height: 30px !important;
}
/deep/.el-scrollbar .el-scrollbar__wrap { overflow-x: hidden; }
</style> 